import { Component, OnInit, OnChanges, Output, Input, EventEmitter } from '@angular/core';

import { IInlineEdit } from '../../inline-edit';


export class InputNumberComponent implements OnInit, OnChanges, IInlineEdit {

	 public data: number = 0;
	 public fingerprint: string = '';
	 public placeholder: string = '';
	 public required: boolean = false;
	 public positiveValue: boolean = false;
	 public onSave = new EventEmitter<any>();
	 public onCancel = new EventEmitter<any>();

	public state: string = 'passive';

	public localData: number = 0;
	public initialData: number = 0;
	public vError: string;

	// Lifecycle Events
	public ngOnInit(): void {
		if (!this.fingerprint) {
			throw 'The "fingerprint" attribute is required!';
		}
	}

	public ngOnChanges(changes: any): void {
		if (changes.hasOwnProperty('data') && changes['data'].currentValue) {
			this.localData = JSON.parse(JSON.stringify(changes['data'].currentValue));
			this.initialData = JSON.parse(JSON.stringify(changes['data'].currentValue));
		}
	}

	// Events
	public onSaveClick(): void {
		if (this.required && this.localData === null) {
			this.vError = `${this.placeholder} is required!`;
			return;
		}
		if (this.positiveValue && this.localData < 1) {
			this.vError = `${this.placeholder} must be greater then 0!`;
			return;
		}
		let data = {
			fingerprint: this.fingerprint,
			data: this.localData
		};
		this.onSave.next(data);
		this.onChangeStateMode('passive');
	}

	public onCancelClick(): void {
		this.restoreData();
		this.onChangeStateMode('passive');
		this.onCancel.next(this.initialData);
	}

	public onChangeStateMode(state: string): void {
		this.vError = null;
		this.state = state;
	}

	// Helpers
	private restoreData(): void {
		this.localData = null;
		this.localData = JSON.parse(JSON.stringify(this.initialData));
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/inline-edit/components/input-number/input-number.component.ts